<template>
  <el-form
    :model="form"
    ref="form">
    <h3 class="blue-text">{{L10n('rfq')}}</h3>
    <div class="row">
      <div class="col-md-4 col-12">
        <el-form-item
          :label="L10n('customer')"
          prop="customerCompanyID"
          :rules="getValidationRule('required')"
          class="material-style"
        >
          <select-company
            :model="form.customerCompanyID"
            @on-data-value="(data) => updateViewData('customerName', data, 'name')"
            :clearable="false"
            disabled
          ></select-company>
        </el-form-item>
      </div>
      <div class="col-md-4 col-12">
        <el-form-item
          :label="L10n('customer-detail')"
          prop="customerCompanyDetailID"
          class="material-style">
          <select-company-detail
            withAutoSelect
            :model="form.customerCompanyDetailID"
            :companyID="form.customerCompanyID"
            disabled
          ></select-company-detail>
        </el-form-item>
      </div>
      <div class="col-md-4 col-12">
        <el-form-item
          :label="L10n('customer-contact')"
          prop="customerContactID"
          :rules="getValidationRule('required')"
          class="material-style">
          <select-company-contact
            :model="form.customerContactID"
            :companyID="form.customerCompanyID"
            @on-data-value="(data) => updateViewData('customerContactName', data, 'name')"
            disabled
          ></select-company-contact>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-12">
        <el-form-item
          :label="L10n('rfq-type')"
          prop="rfqTypeID"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <select-response
            :model="form.rfqTypeID"
            @on-data-value="(data) => updateViewData('rfqTypeTitle', data, 'title')"
            :isLoading="dataSourceRfqType.loading"
            :data="dataSourceRfqType.records"
            disabled
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-md-4 col-12">
        <el-form-item
          :label="L10n('employee')"
          prop="baxEmployeeID"
          class="material-style"
        >
          <select-response
            :model="form.baxEmployeeID"
            @on-data-value="(data) => updateViewData('baxEmployeeName', data, 'title')"
            :data="dataSourceEmployee.records"
            :isLoading="dataSourceEmployee.loading"
            disabled
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-md-4 col-12">
        <el-form-item
          :label="L10n('observation')"
          prop="observation"
          class="material-style">
          <el-input
            :value="form.observation"
            disabled
          ></el-input>
        </el-form-item>
      </div>
      <div class="col-md-3 col-12">
        <el-form-item
          :label="L10n('po')"
          prop="po"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <el-input
            :value="form.po"
            disabled
          />
        </el-form-item>
      </div>
      <div class="col-md-3 col-12">
        <el-form-item
          :label="L10n('po-date')"
          :rules="getValidationRule('required')"
          prop="poDate"
          class="material-style"
        >
          <date-picker
            :value="form.poDate"
            disabled
          ></date-picker>
        </el-form-item>
      </div>
      <div class="col-md-3 col-12">
        <el-form-item
          :label="L10n('requested-date')"
          prop="requestedDate"
          class="material-style"
        >
          <date-picker
            :value="form.requestedDate"
            disabled
          ></date-picker>
        </el-form-item>
      </div>
      <div class="col-md-3 col-12">
        <el-form-item
          prop="pOisOpen"
          class="material-style"
        >
          <el-checkbox
            v-model="form.pOisOpen"
            @change="updateModelItem('pOisOpen', { required: false })"
            :disabled="disabled"
          >
            {{L10n('po-is-open')}}
          </el-checkbox>
        </el-form-item>
      </div>
    </div>
    <view-more>
      <div class="row">
        <div class="col-xl-3 col-md-6 col-12">
          <el-form-item
            :label="L10n('ship-to-company')"
            prop="shipToCompanyID"
            :rules="getValidationRule('required')"
            class="material-style"
          >
            <select-company
              :model="form.shipToCompanyID"
              @on-data-value="(data) => updateViewData('shipToCompanyName', data, 'name')"
              :cleareble="false"
              disabled
            ></select-company>
          </el-form-item>
        </div>
        <div class="col-xl-3 col-md-6 col-12">
          <el-form-item
            :label="L10n('ship-to-company-contact')"
            prop="shipToContactID"
            :rules="getValidationRule('required')"
            class="material-style">
            <select-company-contact
              :model="form.shipToContactID"
              :companyID="form.shipToCompanyID"
              @on-data-value="(data) => updateViewData('shipToContactName', data, 'name')"
              disabled
            ></select-company-contact>
          </el-form-item>
        </div>
        <div class="col-xl-3 col-md-6 col-12">
          <el-form-item
            :label="L10n('ship-to-company-detail')"
            prop="shipToCompanyDetailID"
            :rules="getValidationRule('required')"
            class="material-style">
            <select-company-detail
              :model="form.shipToCompanyDetailID"
              :companyID="form.shipToCompanyID"
              @on-data-value="(data) => updateViewData('shipToCompanyDetailCountry', data, 'country')"
              disabled
            ></select-company-detail>
          </el-form-item>
        </div>
        <div class="col-xl-3 col-md-6 col-12">
          <el-form-item
            :label="L10n('customer-forwarder')"
            prop="customerForwarderID"
            class="material-style"
            :clearable="false"
          >
            <select-forwarder
              :companyID="form.customerCompanyID"
              :model="form.customerForwarderID"
              @on-data-value="(data) => updateViewData('customerForwarderName', data, 'forwarderShipperName')"
              disabled
            ></select-forwarder>
          </el-form-item>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 col-12">
          <el-form-item
            :label="L10n('priority')"
            prop="priorityID"
            class="material-style">
            <select-response
              :model="form.priorityID"
              @on-data-value="(data) => updateViewData('priorityTitle', data, 'title')"
              :isLoading="dataSourcePriority.loading"
              :data="dataSourcePriority.records"
              disabled
            ></select-response>
          </el-form-item>
        </div>
        <div class="col-md-4 col-12">
          <el-form-item
            :label="L10n('order-rating-score')"
            prop="orderRatingScoreID"
            class="material-style"
          >
            <select-response
              :model="form.orderRatingScoreID"
              @on-data-value="(data) => updateViewData('orderRatingScoreText', data, 'scoreText')"
              :fields="{ id: 'id', title: 'scoreText' }"
              :data="dataSourceScore.records"
              :isLoading="dataSourceScore.loading"
              disabled
            ></select-response>
          </el-form-item>
        </div>
        <div class="col-md-4 col-12">
          <el-form-item
            :label="L10n('payment-term')"
            prop="paymentTermID"
            class="material-style">
            <select-response
              :model="form.paymentTermID"
              @on-data-value="(data) => updateViewData('paymentTermTitle', data, 'title')"
              :isLoading="dataSourcePaymentTerm.loading"
              :data="dataSourcePaymentTerm.records"
              disabled
            ></select-response>
          </el-form-item>
        </div>
      </div>
    </view-more>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'
import { mixUpdateCustomer, mixUpdateShipTo } from '@/mixins/companies'
export default {
  name: 'FormRFQ',
  mixins: [Form, mixUpdateCustomer, mixUpdateShipTo],
  components: {
    'view-more': () => import(/* webpackChunkName: 'UI' */ '@/components/UI/ViewMore.vue'),
    'select-forwarder': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectForwarder/Index.vue'),
    'select-company': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompany/Index.vue'),
    'select-company-contact': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompanyContact/Index.vue'),
    'select-company-detail': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompanyDetail/Index.vue')
  },
  props: {
    dataID: { required: true }
  },
  computed: {
    dataSourceEmployee () {
      return this.API('Employees/GetAllDynamic?select=id,name as title&filter=isActive==true')
    },
    dataSourceRfqType () {
      return this.API('RFQTypes/GetAllDynamic?select=id,title')
    },
    dataSourcePriority () {
      return this.API('Priorities/GetAllDynamic?select=id,title&orderBy=title')
    },
    dataSourcePaymentTerm () {
      return this.API('PaymentTerms/GetAllDynamic?select=id,title&orderBy=title')
    },
    dataSourceScore () {
      return this.API('Scores/GetAllDynamic?select=id,scoreText')
    }
  },
  methods: {
    updateModelItem (fieldName, payload = {}) {
      let payloadMixin = { api: `RFQs/Patch/${this.dataID}`, id: this.dataID }
      this.$emit('updateModelItem', fieldName, this.form[fieldName], { ...payloadMixin, ...payload })
    }
  }
}
</script>
